import React from "react"
import mount from "core/mount"
import { Link } from "core/link"
import { menu, settings } from "app/navigation/utils/menu-definitions"

function NavSection({ title, links }) {
  return (
    <div className="mb-4">
      <div className="px-3 mb-1 text-xs font-semibold uppercase tracking-wider text-gray-400">
        {title}
      </div>
      {links.map(link => (
        <Link
          key={link.href}
          href={link.href}
          className="flex items-center px-3 py-1.5 text-sm text-gray-700 rounded-md hover:bg-warm-white-300"
          {...(link.newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          {link.label}
          {link.isPaidFeature && !link.canUseFeature && (
            <span className="ml-auto text-xs text-gray-400">Paid</span>
          )}
          {link.showBetaBadge && (
            <span className="ml-auto text-xs text-gray-400">Beta</span>
          )}
        </Link>
      ))}
    </div>
  )
}

export function VerticalNavSidebar() {
  const user = (window.app && window.app.user) || {}
  const settingsMenu = settings(user.is_admin, {
    accountId: user.account_id,
    accounts: user.accounts
  })

  return (
    <div className="sticky top-0 z-100 flex h-screen w-[250px] min-w-[250px] flex-col overflow-y-auto bg-warm-white-100 py-4">
      <div className="px-3 mb-4">
        <span className="text-lg font-bold text-gray-900">Kit</span>
      </div>

      {Object.values(menu).map(section => (
        <NavSection key={section.title} title={section.title} links={section.links} />
      ))}

      <div className="mt-auto border-t border-gray-200 pt-3">
        {Object.entries(settingsMenu).map(([key, item]) => {
          if (key === "accounts") return null
          return (
            <Link
              key={key}
              href={item.href}
              className="flex items-center px-3 py-1.5 text-sm text-gray-700 rounded-md hover:bg-warm-white-300"
              {...(item.newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              {...(item.method === "delete" ? { "data-method": "delete" } : {})}
            >
              {item.label}
            </Link>
          )
        })}
      </div>
    </div>
  )
}

mount({ VerticalNavSidebar })
